import { FormControl, FormLabel, TextField } from '@mui/material';
import { ComponentProps } from 'react';
import { useFormContext } from 'react-hook-form';

export function CommentBox(props: ComponentProps<'div'>) {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <div {...props}>
      <FormControl fullWidth>
        <FormLabel htmlFor="comments" className="text-base font-semibold">
          Leave a comment (optional)
        </FormLabel>
        <TextField
          id="comments"
          multiline
          minRows={3}
          placeholder=""
          className="w-full"
          {...register('comments')}
          error={!!errors.comments}
          helperText={
            typeof errors.comments?.message === 'string'
              ? errors.comments.message
              : undefined
          }
        />
      </FormControl>
    </div>
  );
}
